import React, { useState } from 'react';
import MainLayout from '../../components/layout/MainLayout';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import DashboardTab from './components/DashboardTab';
import StudentManagementTab from './components/StudentManagementTab';
import EmployerRelationsTab from './components/EmployerRelationsTab';
import TrainingProgramsTab from './components/TrainingProgramsTab';
import PlacementAnalyticsTab from './components/PlacementAnalyticsTab';

const InstitutionManagementPortal = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [institutionInfo] = useState({
    name: 'Mumbai Institute of Technology',
    type: 'Engineering College',
    location: 'Mumbai, Maharashtra',
    establishedYear: '1995',
    accreditation: 'NAAC A+ Grade',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1eb79556e-1767072446865.png",
    logoAlt: 'Modern university campus building with glass facade and students walking'
  });

  const tabs = [
  { id: 'dashboard', label: 'Dashboard', icon: 'LayoutDashboard' },
  { id: 'students', label: 'Student Management', icon: 'Users' },
  { id: 'employers', label: 'Employer Relations', icon: 'Building2' },
  { id: 'training', label: 'Training Programs', icon: 'GraduationCap' },
  { id: 'analytics', label: 'Placement Analytics', icon: 'BarChart3' }];


  const renderTabContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <DashboardTab institutionInfo={institutionInfo} />;
      case 'students':
        return <StudentManagementTab />;
      case 'employers':
        return <EmployerRelationsTab />;
      case 'training':
        return <TrainingProgramsTab />;
      case 'analytics':
        return <PlacementAnalyticsTab />;
      default:
        return <DashboardTab institutionInfo={institutionInfo} />;
    }
  };

  return (
    <MainLayout>
      <div className="space-y-6">
        <div className="bg-card rounded-xl p-6 border border-border shadow-warm-sm">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 rounded-lg overflow-hidden bg-muted flex-shrink-0">
                <img
                  src={institutionInfo?.logo}
                  alt={institutionInfo?.logoAlt}
                  className="w-full h-full object-cover" />

              </div>
              <div>
                <h1 className="text-2xl md:text-3xl font-heading font-bold text-card-foreground">
                  {institutionInfo?.name}
                </h1>
                <div className="flex flex-wrap items-center gap-3 mt-2 text-sm text-muted-foreground">
                  <div className="flex items-center gap-1">
                    <Icon name="Building2" size={14} color="var(--color-muted-foreground)" />
                    <span>{institutionInfo?.type}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Icon name="MapPin" size={14} color="var(--color-muted-foreground)" />
                    <span>{institutionInfo?.location}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Icon name="Award" size={14} color="var(--color-muted-foreground)" />
                    <span>{institutionInfo?.accreditation}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-wrap gap-2">
              <Button variant="default" iconName="UserPlus" size="sm">
                Add New Batch
              </Button>
              <Button variant="outline" iconName="Calendar" size="sm">
                Schedule Campus Drive
              </Button>
              <Button variant="outline" iconName="FileText" size="sm">
                Generate Reports
              </Button>
            </div>
          </div>
        </div>

        <div className="bg-card rounded-xl border border-border shadow-warm-sm overflow-hidden">
          <div className="border-b border-border overflow-x-auto">
            <div className="flex min-w-max">
              {tabs?.map((tab) =>
              <button
                key={tab?.id}
                onClick={() => setActiveTab(tab?.id)}
                className={`flex items-center gap-2 px-6 py-4 text-sm font-medium transition-smooth border-b-2 whitespace-nowrap ${
                activeTab === tab?.id ?
                'border-primary text-primary bg-primary/5' : 'border-transparent text-muted-foreground hover:text-foreground hover:bg-muted/50'}`
                }>

                  <Icon name={tab?.icon} size={18} color={activeTab === tab?.id ? 'var(--color-primary)' : 'var(--color-muted-foreground)'} />
                  <span>{tab?.label}</span>
                </button>
              )}
            </div>
          </div>

          <div className="p-6">
            {renderTabContent()}
          </div>
        </div>
      </div>
    </MainLayout>);

};

export default InstitutionManagementPortal;